import { Navigate } from "react-router-dom";

function getTokenPayload() {
  try {
    const token = localStorage.getItem("paladin_admin_token");
    if (!token) return null;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 > Date.now() ? payload : null;
  } catch {
    return null;
  }
}

export default function ProtectedRoute({ children }) {
  return getTokenPayload() ? children : <Navigate to="/admin/login" replace />;
}

export { getTokenPayload };
